import { checkNoChosenYears } from 'portfolio3/features/pdf/utils/checkNoChosenYears';
import { checkSectionEmptiness } from 'portfolio3/features/pdf/utils/checkSectionEmptiness';
import { sortPeriods } from 'portfolio3/features/pdf/utils/sortPeriods';
import { createSelector } from 'reselect';
import { chosenYearsSelector } from 'selectors/drawers';
import { academicYearsTouchedSelector } from 'selectors/drawers/linkSharingDrawer';

import { scienceContestsYearsSelector } from './scienceContestsYearsSelector';
import { scienceOccupationsYearsSelector } from './scienceOccupationsYearsSelector';
import { scienceProjectsYearsSelector } from './scienceProjectsYearsSelector';
import { scienceRewardsYearsSelector } from './scienceRewardsYearsSelector';

export const scienceSectionAcademicYearsDataSelector = createSelector(
  [
    // Данные раздела Наука
    scienceRewardsYearsSelector,
    scienceProjectsYearsSelector,
    scienceOccupationsYearsSelector,
    scienceContestsYearsSelector,
    // Выбранные года
    chosenYearsSelector,
    academicYearsTouchedSelector,
  ],
  (
    scienceContestsYears,

    scienceProjectsYears,
    scienceOccupationsYears,
    scienceContests,
    chosenYears,
    academicYearsTouched,
  ) => {
    const emptyDataMap = {
      scienceReward: checkNoChosenYears(scienceContestsYears, chosenYears, academicYearsTouched),
      projects: checkNoChosenYears(scienceProjectsYears, chosenYears, academicYearsTouched),
      scienceEmployments: checkNoChosenYears(scienceOccupationsYears, chosenYears, academicYearsTouched),
      scienceContest: checkNoChosenYears(scienceContests, chosenYears, academicYearsTouched),
    };

    const periods: Set<string> = new Set([
      ...scienceContestsYears,
      ...scienceProjectsYears,
      ...scienceOccupationsYears,
      ...scienceContests,
    ]);

    return {
      academicYears: sortPeriods(periods),
      emptyDataMap: {
        ...emptyDataMap,
        science: checkSectionEmptiness(emptyDataMap),
      },
    };
  },
);
